(function () {
    "use strict";
    angular.module("app").directive("sendToMultiButton", MultiSendToDirective);
    function MultiSendToDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                description: "@",
                buttons: "=?",
                iconState: "@"
            },
            template: `
                 <div id="sliderDiv" class="tab-panel" style="display: block; position: fixed; width: auto; bottom: 50px; cursor:move; z-index:10; background-color:white; max-height: min-content;">
                    <i class="glyphicon " ng-class="iconState"></i>
                    <p>{{ description }}</p>
                    <button class="ng-scope btn" ng-repeat="b in buttons" style="font-size: large;height: 100px;" ng-class="buttonClass(b)" ng-click="Send(b)">
                        {{ b.buttonText }}
                    </button>
                </div>
                `,
            link: function ($scope, element) {
                $(element).css("left", "-250px");
                $(element).animate({ "left": "+=265px" }, "slow");
                $(element).draggable();
                $scope.slideUp = true;
                $scope.Send = (button) => { if (angular.isFunction(button.onSend)) button.onSend(); };
                $scope.iconState = !$scope.iconState || $scope.iconState === "" ? "fa fa-thumbs-up" : $scope.iconState;
                $scope.buttonClass = (button) => !button.buttonClass ? "btn-success" : button.buttonClass;
            }
        };
    }
})();